export default {
  growthbookConfig: state => state.growthbookPayload,
}
